const SEMANTIC_COLOR_VARS = {
	/** AUTO_GEN_FIGMA_SEMANTIC_COLOR_VARS_START */
	'text-default': '--color-text-default',
	'text-secondary': '--color-text-secondary',
	'text-tertiary': '--color-text-tertiary',
	'input-border': '--color-input-border',
	'tooltip-bg': '--color-tooltip-bg',
	'stroke-divider': '--color-stroke-divider',
	'button-secondary-bg': '--color-button-secondary-bg',
	'container-bg': '--color-container-bg',
	'main-bg': '--color-main-bg',
	black: '--color-black',
	white: '--color-white',
	'button-primary-bg': '--color-button-primary-bg',
	'purple-link': '--color-purple-link',
	'warn-orange': '--color-warn-orange',
	'negative-red': '--color-negative-red',
	'positive-green': '--color-positive-green',
	'input-bg': '--color-input-bg',
	'button-disabled': '--color-button-disabled',
	'text-disabled': '--color-text-disabled',
	'text-positive-green-button': '--color-text-positive-green-button',
	'text-negative-red-button': '--color-text-negative-red-button',
	overlay: '--color-overlay',
	'button-selector': '--color-button-selector',
	'negative-red-secondary-bg': '--color-negative-red-secondary-bg',
	'positive-green-secondary-bg': '--color-positive-green-secondary-bg',
	'warn-orange-secondary-bg': '--color-warn-orange-secondary-bg',
	'purple-bg': '--color-purple-bg',
	'button-primary-bg-hover': '--color-button-primary-bg-hover',
	'button-secondary-bg-hover': '--color-button-secondary-bg-hover',
	'star-yellow': '--color-star-yellow',
	'star-yellow-bg': '--color-star-yellow-bg',
	shadow: '--color-shadow',
	'purple-link-hover': '--color-purple-link-hover',
	'menu-bg': '--color-menu-bg',
	/** AUTO_GEN_FIGMA_SEMANTIC_COLOR_VARS_END */
};

const BASE_COLOR_VARS = {
	/** AUTO_GEN_FIGMA_BASE_COLOR_VARS_START */
	'neutral-50': '--color-neutral-50',
	'neutral-100': '--color-neutral-100',
	'neutral-200': '--color-neutral-200',
	'neutral-300': '--color-neutral-300',
	'neutral-400': '--color-neutral-400',
	'neutral-500': '--color-neutral-500',
	'neutral-600': '--color-neutral-600',
	'neutral-700': '--color-neutral-700',
	'neutral-800': '--color-neutral-800',
	'neutral-900': '--color-neutral-900',
	'black-50': '--color-black-50',
	'black-100': '--color-black-100',
	'black-200': '--color-black-200',
	'black-300': '--color-black-300',
	'black-400': '--color-black-400',
	'black-500': '--color-black-500',
	'black-600': '--color-black-600',
	'black-700': '--color-black-700',
	'black-800': '--color-black-800',
	'black-900': '--color-black-900',
	'dark-purple-50': '--color-dark-purple-50',
	'dark-purple-100': '--color-dark-purple-100',
	'dark-purple-200': '--color-dark-purple-200',
	'dark-purple-300': '--color-dark-purple-300',
	'dark-purple-400': '--color-dark-purple-400',
	'dark-purple-500': '--color-dark-purple-500',
	'dark-purple-600': '--color-dark-purple-600',
	'dark-purple-700': '--color-dark-purple-700',
	'dark-purple-800': '--color-dark-purple-800',
	'dark-purple-900': '--color-dark-purple-900',
	'light-purple-50': '--color-light-purple-50',
	'royal-purple-50': '--color-royal-purple-50',
	'light-purple-100': '--color-light-purple-100',
	'light-purple-200': '--color-light-purple-200',
	'light-purple-300': '--color-light-purple-300',
	'light-purple-400': '--color-light-purple-400',
	'light-purple-500': '--color-light-purple-500',
	'light-purple-600': '--color-light-purple-600',
	'light-purple-700': '--color-light-purple-700',
	'light-purple-800': '--color-light-purple-800',
	'light-purple-900': '--color-light-purple-900',
	'green-50': '--color-green-50',
	'royal-purple-100': '--color-royal-purple-100',
	'royal-purple-200': '--color-royal-purple-200',
	'royal-purple-300': '--color-royal-purple-300',
	'royal-purple-400': '--color-royal-purple-400',
	'royal-purple-500': '--color-royal-purple-500',
	'royal-purple-600': '--color-royal-purple-600',
	'royal-purple-700': '--color-royal-purple-700',
	'royal-purple-800': '--color-royal-purple-800',
	'royal-purple-900': '--color-royal-purple-900',
	'red-50': '--color-red-50',
	'red-100': '--color-red-100',
	'red-200': '--color-red-200',
	'red-300': '--color-red-300',
	'red-400': '--color-red-400',
	'red-500': '--color-red-500',
	'red-600': '--color-red-600',
	'red-700': '--color-red-700',
	'red-800': '--color-red-800',
	'red-900': '--color-red-900',
	'green-100': '--color-green-100',
	'green-200': '--color-green-200',
	'green-300': '--color-green-300',
	'green-400': '--color-green-400',
	'green-500': '--color-green-500',
	'green-600': '--color-green-600',
	'green-700': '--color-green-700',
	'green-800': '--color-green-800',
	'green-900': '--color-green-900',
	'orange-50': '--color-orange-50',
	'orange-100': '--color-orange-100',
	'orange-200': '--color-orange-200',
	'orange-300': '--color-orange-300',
	'orange-400': '--color-orange-400',
	'orange-500': '--color-orange-500',
	'orange-600': '--color-orange-600',
	'orange-700': '--color-orange-700',
	'orange-800': '--color-orange-800',
	'orange-900': '--color-orange-900',
	/** AUTO_GEN_FIGMA_BASE_COLOR_VARS_END */
};

export const COLOR_VARS = {
	...SEMANTIC_COLOR_VARS,
	...BASE_COLOR_VARS,
} as const;
